// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Compact embedded shipments table on order details — no wide min-width / extra column gap */
.sales-order-shipments-table .production-scroll {
  --rdt-min: 100%;
}

.sales-order-shipments-table .production-table {
  min-width: 0 !important;
  width: 100% !important;
  table-layout: auto;
}

.sales-order-shipments-table .production-th {
  padding: 8px 10px !important;
  font-size: 0.8125rem;
}

.sales-order-shipments-table .production-td {
  padding: 8px 10px !important;
}

.sales-order-shipments-table .production-th .th-text,
.sales-order-shipments-table .production-td .text-sm {
  white-space: normal;
  word-break: break-word;
}

.sales-order-shipments-table .production-td .order-link-1 {
  white-space: normal;
  word-break: break-all;
  max-width: 100%;
}

.sales-order-shipments-table .production-td .gap-2 {
  gap: 0.35rem !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/SalesOrderDetails/SalesOrderDetailsShipmentsTable.css"],"names":[],"mappings":"AAAA,6FAA6F;AAC7F;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,oBAAoB;AACtB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;EAEE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB","sourcesContent":["/* Compact embedded shipments table on order details — no wide min-width / extra column gap */\n.sales-order-shipments-table .production-scroll {\n  --rdt-min: 100%;\n}\n\n.sales-order-shipments-table .production-table {\n  min-width: 0 !important;\n  width: 100% !important;\n  table-layout: auto;\n}\n\n.sales-order-shipments-table .production-th {\n  padding: 8px 10px !important;\n  font-size: 0.8125rem;\n}\n\n.sales-order-shipments-table .production-td {\n  padding: 8px 10px !important;\n}\n\n.sales-order-shipments-table .production-th .th-text,\n.sales-order-shipments-table .production-td .text-sm {\n  white-space: normal;\n  word-break: break-word;\n}\n\n.sales-order-shipments-table .production-td .order-link-1 {\n  white-space: normal;\n  word-break: break-all;\n  max-width: 100%;\n}\n\n.sales-order-shipments-table .production-td .gap-2 {\n  gap: 0.35rem !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
